import './style.scss';

const CheckBox = ({ onChange, checked = false, id, label, ...props }) => {
  const handleClick = () => onChange({ target: { id, value: !checked } });
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <span className="checkbox-wrapper" onClick={handleClick}>
      <input
        onChange={handleClick}
        type="checkbox"
        checked={checked}
        id={id}
        className="visually-hidden"
        tabIndex={-1}
        aria-hidden="true"
      />
      <span
        className="checkbox"
        role="checkbox"
        aria-checked={checked}
        aria-labelledby={`${id}-label`}
        tabIndex={0}
        onKeyDown={handleKeyDown}
        {...props}
      >
        <span className="checkbox__inner"></span>
        <span className="checkbox__deco"></span>
      </span>
    </span>
  );
};

export default CheckBox;
